<div class="footer-grid-container">
  <a class="contact" href="mailto:{{companyInformation.email}}">Contact</a>

  <div class="copyright">&copy; {{companyInformation.name}} {{ currentYear }}</div>

  <div class="version"> <span>v{{ currentApplicationVersion }}</span> </div>
</div>
